import { render, staticRenderFns } from "./DOTMap.vue?vue&type=template&id=95ef56de&scoped=true&"
import script from "./DOTMap.vue?vue&type=script&lang=ts&"
export * from "./DOTMap.vue?vue&type=script&lang=ts&"
import style0 from "./DOTMap.vue?vue&type=style&index=0&id=95ef56de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ef56de",
  null
  
)

export default component.exports